// extracted by mini-css-extract-plugin
export default {"page":"login_page__1eAeo","card":"login_card__P4EGn","logo":"login_logo__xurd+","error":"login_error__euuUn","footer":"login_footer__AzVdY"};